// Mirrors Program.is_dual_diagnosis_program on the backend, which identifies Dual
// programs by name because Dual and Standard programs share a program family.
const isDualDiagnosisProgram = (programName: string | null | undefined): boolean =>
  /\bdual\b/i.test(programName ?? '');

export default isDualDiagnosisProgram;
